export const DARK_GREY = '#676767';
export const FJELL_70 = '#4d689f';
export const FROST = '#7EB5D2';
